import Vue from 'vue'
import firebase from 'firebase';

const state = {
  view: 'user',
  logged_in: true,
  logged_out: false, 
  user: {"uid":"x3tTLMFYvIMGAG3mHPbeWGGVJBM2","email":"g.schmidt@m.works","display_name":"Günter Schmidt"}, 
  subscriptions: []
};

const actions = {
  setView( {commit, dispatch}, view ){
    commit("SET_VIEW", view );
    dispatch("triggerRegisterModules", view, {root: true})
  },  
  register({commit, dispatch}, {email, password, first_name, last_name } ){
    return new Promise((resolve, reject) => {
        firebase.auth().createUserWithEmailAndPassword(email, password).then( (response) => {
          var display_name = `${first_name} ${last_name}`;
          response.user.updateProfile({
            displayName: display_name
          })
          commit("SET_USER_DETAILS", {
            email: response.user.email, 
            uid: response.user.uid,
            display_name: display_name,
            last_name: last_name,
            registration_method: "email"
          })
          dispatch("user/createUserDocument", {}, {root: true} ).then(( ) => {
            dispatch("mail/verifyEmail", {}, {root: true} );
            resolve();
          })
        }).catch( error  => {
          reject(error)
        })
    })
  },
  loginWithGoogle( {commit, dispatch} ){
    return new Promise((resolve, reject) => {
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().languageCode = 'en';
      firebase.auth().signInWithPopup(provider).then(function(result) {
        var user =  result.user;
        commit("SUCCESSFUL_LOG_IN", user)
        dispatch("countLogin", user.uid );
        if( result.additionalUserInfo.isNewUser ){
          commit("SET_USER_DETAILS", {
            registration_method: "google",
            first_name: result.additionalUserInfo.profile.given_name,
            last_name: result.additionalUserInfo.profile.family_name,
            profile_image: result.additionalUserInfo.profile.picture
          });
          dispatch("user/createUserDocument", {}, {root: true})
        }
        else{
          resolve()
        }
      }).catch(function(error) {
        reject(error)
      });
    })
  },
  loginWithPassword( {commit, dispatch}, { email, password }) {
    return new Promise((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(email, password)
        .then((result) => {
          var user = result.user;
          commit("SUCCESSFUL_LOG_IN", user );
          dispatch("countLogin", user.uid );
          resolve(user);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout( {commit, dispatch} ) {
    return new Promise((resolve, reject) => {
      firebase.auth().signOut().then(function() {
        commit("SUCCESSFUL_LOG_OUT");
        dispatch("detachAllSubscriptions");
        dispatch("unregisterModules", false, {root: true})
        resolve();
      }).catch(function(error) {
        reject(error);
      });
    });
  },
  checkAuth({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          commit("SUCCESSFUL_LOG_IN", user );
          dispatch("user/watchUserDocument", user.uid, {root: true} );
          resolve();
        }
        else {
          reject('User is not logged in.');
        }
      });
    });
  },
  countLogin({dispatch}, id){
    const increment = firebase.firestore.FieldValue.increment(1);
    dispatch("updateDoc", {
      doc: `users/${id}`, 
      data: {
        login_count: increment
      }, 
      action: "update"
    }, {root: true}
    ).catch(() => {})
  },
  detachAllSubscriptions({state}){
    state.subscriptions.forEach( subscription => {
      subscription();
    })
  },
  confirmPasswordReset( {state }, {action_code, password } ){
    state;
    return new Promise((resolve, reject) => {
      firebase.auth().confirmPasswordReset(action_code, password ).then( resp => {
        resolve( resp );
      }).catch(( ) => {
        reject();
      })
    })
  },
  applyActionCode( state, action_code ){
    state;
    return new Promise((resolve, reject) => {   
      firebase.auth().applyActionCode(action_code).then( () => {
        resolve(true);
      }).catch(() => {
        reject();
      })
    })
  },
  verifyPasswordResetCode( {state }, action_code ){
    state;
    return new Promise((resolve, reject) => {
      firebase.auth().verifyPasswordResetCode(action_code).then( email => {
        resolve(email);
      }).catch(( ) => {
        reject();
      })
    })
  }
};

const mutations = {
  LOG_SUBSCRIPTION( state, subscription ){
    state.subscriptions.push(subscription)
  },
  SUCCESSFUL_LOG_OUT(state ) {
    let now = Math.round((new Date()).getTime() / 1000);
    Vue.set( state, "logged_out", now ) 
    Vue.set( state, "logged_in", false ) 
    Vue.set( state, "user", false )  
    Vue.set( state, "view", "visitor" )  
  },
  SUCCESSFUL_LOG_IN( state, user ) {
    if( !state.user ){
      Vue.set( state, "user", {} )
    }
    let now = Math.round((new Date()).getTime() / 1000);
    Vue.set( state, "logged_in", now ) 
    Vue.set( state.user, "uid", user.uid );
    Vue.set( state.user, "email", user.email );
    if(user.displayName){
      Vue.set( state.user, "display_name", user.displayName );
    }
  },
  SET_USER_DETAILS(state, object ){
    if( !state.user ){
      Vue.set( state, "user", {} )
    }
    for( var key in object ){
      Vue.set( state.user, key, object[key] )
    }
  },
  SET_VIEW(state, view){
    Vue.set(state, "view", view );
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
